import { Link } from "react-router-dom";
import { useRef } from "react";
import { useOurObsessions } from "../hooks/useOurObsessions";
import "../styles/HomePage.css";

function OurObsessions() {
  const sectionRef = useRef(null);
  const imageRef = useRef(null);

  const { data, loading } = useOurObsessions(sectionRef, imageRef);

  if (loading || !data) return null;

  return (
    <section ref={sectionRef} className="obsession-section">
      <div className="txt_root_warp">
        <h2 className="obsession-title web">OUR OBSESSIONS</h2>

        <div style={{ marginBottom: "28px" }}>
          <h2 className="obsession-title mob"> OUR OBSESSIONS </h2>
        </div>
      </div>

      <div className="obsession-content">
        {/* Desktop Image */}
        <div className="obsession-image">
          {data.media && (
            <img
              ref={imageRef}
              src={data.media}
              className="img_video_track"
              alt="Our Obsessions"
            />
          )}
        </div>

        <div className="obsession-text">
          {data.content && (
            <div
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          )}

          {data.action_url && (
            <Link to={`pages/${data.action_url}`}>
              <button className="hero-button">
                MORE ABOUT US
              </button>
            </Link>
          )}

          {/* Mobile Image (no zoom effect here) */}
          <div className="obsession-image_mlb">
            {data.media && (
              <img
                src={data.media}
                className="img_video_track"
                alt="Our Obsessions"
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurObsessions;